import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import problemResults from "./modules/problemResults";
import { db } from "../plugins/firebase";
import { Loading } from "element-ui";
import Lesson from "@/pages/Lesson/index";
import firebase from "firebase/app";
import "firebase/auth";

Vue.use(Vuex);

const modules = {
  auth,
  problemResults
};

export default new Vuex.Store({
  // plugins: [createPersistedState()],
  modules,
  state: initialState,
  getters: {},
  mutations: {
    showMicGuideModal(state) {
      state.showedMicGuideModal = true;
    },
    resetState(state) {
      // acquire initial state
      const s = initialState();
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },
    setInitLoaded(state) {
      state.initLoaded = true;
    },
    setBgUrl(state, payload) {
      state.bgUrl = payload;
    },
    setName(state, payload) {
      state.userData.name = payload;
    },
    setLessonType(state, payload) {
      if (payload === "consonant") {
        state.selectedCategory = "consonant";
        state.selectedLessons = state.allLessons.filter(lesson => {
          return lesson.category === "consonant";
        });
      } else if (payload === "vowel") {
        state.selectedCategory = "vowel";

        state.selectedLessons = state.allLessons.filter(lesson => {
          return lesson.category === "vowel";
        });
      } else if (payload === "exercise") {
        state.selectedCategory = "exercise";
        state.selectedLessons = [];
      } else {
        state.selectedCategory = "search";

        state.selectedLessons = payload.map(phoneme => {
          return state.allLessons.filter(lesson => {
            return lesson.titlePhoneme === phoneme;
          })[0];
        });
      }
    },
    setAllLessons(state, payload) {
      state.allLessons = payload;
      state.lessonsLoaded = true;
    },
    setAutoNextProb(state, payload) {
      state.autoNextProb = payload;
    },
    setUserData(state, payload) {
      state.userData = Object.assign(state.userData, payload);
    },
    incrementTotalScore(state, payload) {
      // state.userData.totalScore = state.userData.totalScore + payload;
    }
  },
  actions: {
    loadAllLessons({ commit, state }) {
      return new Promise(resolve => {
        if (true) {
          db.collection("lessons")
            .doc("basic")
            .get()
            .then(snapshot => {
              commit("setAllLessons", snapshot.data().lessons);
              if (!state.initLoaded) {
                commit("setLessonType", "consonant");
              }
              commit("setInitLoaded");
              resolve();
            });
        } else {
          resolve();
        }
      });
    },
    // How to listen the doc
    async loadUserData({ commit, state }) {
      if (firebase.auth().currentUser) {
        return new Promise((resolve, reject) => {
          const userRef = db.collection("users").doc(state.auth.user.uid);
          // Listen update

          if (!state.userDataInitialized) {
            userRef.onSnapshot(snapshot => {
              const userData = snapshot.data();
              commit("setUserData", userData);
            });
          }

          userRef.get().then(snapshot => {
            const userData = snapshot.data();
            commit("setUserData", userData);
            state.userDataInitialized = true;
            resolve();
          });
        });
      } else {
        console.log("not logged in");
      }
    }
  }
});

function initialState() {
  return {
    userDataInitialized: false,
    initLoaded: false,
    selectedCategory: "consonant",
    selectedLessons: [],
    lessonsLoaded: false,
    allLessons: [],
    showedMicGuideModal: false,
    autoNextProb: false,
    userData: {
      name: "DEFAULT_NAME",
      unlock: false,
      unlockedTime: "",
      totalScore: 0,
      completedByPhoneme: {},
      trialed: false,
      serialUsed: false,
      subscription: {
        status: "",
        current_period_start: "",
        current_period_end: ""
      }
    },
    bgUrl: `data:image/svg+xml;charset=utf8,%20%3Csvg%20xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%20xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%20xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20id%3D%22svg821%22%20version%3D%221.1%22%20viewBox%3D%220%200%20507.99999%20285.75001%22%20height%3D%221080%22%20width%3D%221920%22%3E%20%3Cdefs%20id%3D%22defs815%22%20%2F%3E%20%3Cmetadata%20id%3D%22metadata818%22%3E%20%3Crdf%3ARDF%3E%20%3Ccc%3AWork%20rdf%3Aabout%3D%22%22%3E%20%3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%20%3Cdc%3Atype%20rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22%20%2F%3E%20%3Cdc%3Atitle%3E%3C%2Fdc%3Atitle%3E%20%3C%2Fcc%3AWork%3E%20%3C%2Frdf%3ARDF%3E%20%3C%2Fmetadata%3E%20%3Cg%20transform%3D%22translate(-100%2C-11.249983)%22%20id%3D%22layer1%22%3E%20%3Cpath%20id%3D%22path1366%22%20d%3D%22M%20-8.315476%2C0.28867346%20-33.639881%2C299.64581%20153.08036%2C4.0684352%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%3Bfill-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1368%22%20d%3D%22m%20335.26488%2C-152.79168%2062.36607%2C319.76785%20129.26784%2C22.67858%20z%22%20style%3D%22fill%3A%23f6f6f6%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1385%22%20d%3D%22M%20-25.702381%2C356.34223%20318.63393%2C20.699388%20118.68453%2C-12.184539%20-63.877977%2C360.87795%20Z%22%20style%3D%22fill%3A%23f0f0f0%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1368-0%22%20d%3D%22M%20-17.575879%2C47.535698%2044.790191%2C367.30355%20174.05803%2C389.98213%20Z%22%20style%3D%22fill%3A%23f6f6f6%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-9%22%20d%3D%22M%20118.68453%2C-12.184539%2069.163539%2C405.10117%20434.28854%2C-6.91578%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.43682703px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-4%22%20d%3D%22M%20346.98214%2C39.598196%20321.65774%2C338.95535%20508.37797%2C43.377956%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%20%22%20%2F%3E%20%3Cpath%20id%3D%22path1385-9%22%20d%3D%22M%20127.75595%2C341.03421%20472.09227%2C5.3913519%20272.14286%2C-27.492575%2089.580357%2C345.56993%20Z%22%20style%3D%22fill%3A%23f0f0f0%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-9-7%22%20d%3D%22M%20514.80357%2C297.55545%2089.202353%2C319.70147%20509.42982%2C156.41576%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.29501727px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1366-9-76%22%20d%3D%22M%20364.37516%2C-36.375026%20314.85417%2C380.9107%20679.97917%2C-31.106266%20Z%22%20style%3D%22fill%3A%23fbfbfb%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.43682703px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3Cpath%20id%3D%22path1385-6%22%20d%3D%22M%20423.71131%2C430.61456%20768.04763%2C94.971709%20568.09822%2C62.087782%20385.53572%2C435.15028%20Z%22%20style%3D%22fill%3A%23f0f0f0%3Bfill-opacity%3A0.5%3Bstroke%3Anone%3Bstroke-width%3A0.26458332px%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-opacity%3A0.5%22%20%2F%3E%20%3C%2Fg%3E%3C%2Fsvg%3E`
  };
}
